namespace Areas.Event.Profile {
    "use strict";

    export function updateEvent() {
        const form = $("#EventProfileForm").dxForm("instance");
        const newData: any = form.option("formData");

        const keyId: any = form.option("KeyId");

        if (keyId != null) {
            sendRequest(`/Event/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function downloadAttachmentLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.attachmentId; },
            "<a href= '/File/Get/Attachment/{placeholder}'>Download</a>");
    } 

    export function onContentReady() {
        Areas.ckeditorInit('description');
    }
}